import axios from "axios";
import { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { URLS } from "../../config";
import { hooks } from "../../hooks";
import { items } from "../../items";
import { custom } from "../../custom";
import { theme } from "../../constants";
import { actions } from "../../store/actions";
import { components } from "../../components";

export const Home = () => {
  const dispatch = hooks.useAppDispatch();
  const navigate = hooks.useAppNavigate();
  const { list } = hooks.useAppSelector((state) => state.cartSlice);

  const [loading, setLoading] = useState(true);
  const [noCatalogue, setNoCatalogue] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [productsData, setProductsData] = useState([]);
  const [carouselData, setCarouselData] = useState([]);

  const getSubdomain = () => {
    const hostname = window.location.hostname;
    let parts = hostname.split(".");
    if (parts[0] === "www") {
      parts.shift();
    }
    if (parts.length > 2) {
      return parts[0];
    }
    return null;
  };

  const getData = async () => {
    const storedUserId = localStorage.getItem("userId");
    setLoading(true);
    try {
      const products = await axios
        .get(`${URLS.GET_PRODUCTS}?user_id=${storedUserId}`)
        .then((res) => res?.data?.item_list);
      setProductsData(products);

      const carousel = await axios
        .post(URLS.GET_CAROUSEL, { user_id: storedUserId })
        .then((res) => res.data?.data);
      setCarouselData(carousel);

      console.log("Fetched products:", products);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getProductListWithQuantities = (productData, list = []) => {
    return (productData || []).map((product) => {
      const updatedItems =
        product.items?.map((item) => {
          const cartItem = (list || []).find((cart) => cart.id === item.id);
          return {
            ...item,
            quantity: cartItem ? cartItem.quantity : 0,
          };
        }) || [];

      return {
        ...product,
        items: updatedItems,
      };
    });
  };

  const productsWithQuantities = getProductListWithQuantities(productsData, list);

  useEffect(() => {
    const bootstrap = async () => {
      const subdomain = getSubdomain();
      if (subdomain) {
        setLoading(true);
        try {
          const res = await axios.get(
            `https://catalogmakerpro.in/server/CatalogMakerPro/get_userid_by_subdomain.php?subdomain=${subdomain}`
          );
          if (String(res?.data?.res_code) === "200" && res?.data?.user_id) {
            const rawUserId = res.data.user_id;
            const userIdNumber = parseInt(rawUserId, 10);
            localStorage.setItem("userId", userIdNumber.toString());
            localStorage.setItem("base64Id_userId", rawUserId.toString());
            await getData();
          } else {
            setNoCatalogue(true);
            setLoading(false);
          }
        } catch (error) {
          console.error("Subdomain lookup error:", error);
          setNoCatalogue(true);
          setLoading(false);
        }
      } else {
        const url = window.location.href;
        const base64Id = url.split("/").pop();
        try {
          const decodedString = atob(base64Id);
          const userIdNumber = parseInt(decodedString, 10);
          localStorage.setItem("userId", userIdNumber.toString());
          localStorage.setItem("base64Id_userId", base64Id.toString());
        } catch (e) {
          console.error("Base64 decode error:", e);
        }
        await getData();
      }
    };

    bootstrap();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    AOS.init();
  }, []);

  const handleSlideChange = (index) => {
    setActiveIndex(index);
  };

  const renderNoCatalogue = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: "24px",
        textAlign: "center",
        backgroundColor: "#F8FAFC",
        animation: "fadeIn 0.6s ease-out forwards",
      }}
    >
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes floatIcon {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }
      `}</style>
      
      <div
        style={{
          width: 100,
          height: 100,
          borderRadius: "50%",
          backgroundColor: "#FFF0F0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 24,
          boxShadow: "0 10px 25px -5px rgba(239, 68, 68, 0.15)",
          animation: "floatIcon 3s ease-in-out infinite",
        }}
      >
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#EF4444"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
          <line x1="3" y1="6" x2="21" y2="6" />
          <path d="M16 10a4 4 0 0 1-8 0" />
          <line x1="4" y1="4" x2="20" y2="20" />
        </svg>
      </div>

      <h2
        style={{
          fontSize: 24,
          fontWeight: 700,
          color: theme.colors.mainColor || "#193364",
          marginBottom: 10,
          fontFamily: "Mulish-Bold, sans-serif",
        }}
      >
        Catalogue Not Found
      </h2>

      <p
        style={{
          fontSize: 15,
          color: "#64748B",
          maxWidth: 360,
          lineHeight: 1.6,
          margin: "0 0 28px 0",
          fontFamily: "Mulish-Regular, sans-serif",
        }}
      >
        This shop catalogue is not active or does not exist. Please check the link and try again.
      </p>

      <button
        onClick={() => window.location.reload()}
        style={{
          padding: "12px 28px",
          backgroundColor: theme.colors.mainColor || "#193364",
          color: "#FFFFFF",
          border: "none",
          borderRadius: 25,
          fontSize: 14,
          fontWeight: 600,
          cursor: "pointer",
          boxShadow: "0 4px 12px rgba(25, 51, 100, 0.2)",
          transition: "transform 0.2s ease, background-color 0.2s ease",
        }}
      >
        Refresh Page
      </button>
    </div>
  );

  const renderHeader = () => (
    <components.Header burger={true} basket={true} line={true} searchBar={true} />
  );

  const renderCarousel = () => (
    <div style={{ marginBottom: 22 }} data-aos="fade">
      <Carousel
        infiniteLoop={false}
        showStatus={false}
        showThumbs={false}
        thumbWidth={22}
        showIndicators={false}
        showArrows={false}
        onChange={handleSlideChange}
        swipeable={true}
        emulateTouch={true}
      >
        {carouselData?.map((item, index) => (
          <img
            key={index}
            src={item?.desktop_banner}
            alt="Carousel"
            style={{
              width: "100%",
              height: 300,
              objectFit: "contain",
              backgroundColor: theme.colors.imageBackground,
            }}
          />
        ))}
      </Carousel>
    </div>
  );

  const renderIndicator = () => (
    <div style={{ display: "flex", justifyContent: "center", marginBottom: 40 }}>
      {carouselData?.map((item, index) => {
        const isSelected = index === activeIndex;
        return (
          <div
            key={index}
            style={{
              background: isSelected ? theme.colors.mainColor : "#E8EFF4",
              display: "inline-block",
              width: 22,
              height: 6,
              margin: "0 6px",
              borderRadius: 6,
            }}
          />
        );
      })}
    </div>
  );

  const renderBestSellers = () => {
    const filteredCategories = productsWithQuantities?.filter(
      (ele) =>
        ele?.items?.length > 0 &&
        ele.items.some(
          (item) => String(item.product_status).toLowerCase() !== "inactive"
        )
    );

    return filteredCategories?.map((ele, index) => (
      <div
        key={index}
        style={{ marginBottom: 40, display: "flex", flexDirection: "column" }}
      >
        <components.BlockHeading
          title={ele?.category_name}
          containerStyle={{ padding: "0 20px 0", marginBottom: 14 }}
          viewAllOnClick={() => {
            dispatch(actions.resetFilters());
            navigate("/Shop", {
              state: { products: ele, title: ele?.category_name },
            });
          }}
        />
        <div>
          {ele?.items
            ?.filter(
              (item) =>
                String(item.product_status).toLowerCase() === "active" ||
                String(item.product_status).toLowerCase() === "out of stock"
            )
            .slice(0, 5)
            .map((item, index, array) => {
              const isLast = index === array.length - 1;
              return (
                <items.ProductCard isLast={isLast} item={item} version={1} key={item.id} />
              );
            })}
        </div>
      </div>
    ));
  };

  const renderContent = () => {
    if (loading) return <components.TabLoader />;
    return (
      <main style={{ paddingBottom: 64, display: "flex", flexDirection: "column" }}>
        {renderCarousel()}
        {renderIndicator()}
        {renderBestSellers()}
      </main>
    );
  };

  const renderBottomTabBar = () => <components.BottomTabBar />;

  if (noCatalogue) {
    return renderNoCatalogue();
  }

  return (
    <>
      {renderHeader()}
      {renderContent()}
      {list?.length > 0 ? renderBottomTabBar() : null}
    </>
  );
};
